import { useState } from 'react';
import { topicTags } from '@/mocks/home';
import { useToast } from '@/components/base/Toast';
import SectionHeading from '@/pages/home/components/SectionHeading';

const sizeClass: Record<string, string> = {
  lg: 'text-lg md:text-xl px-5 py-3 font-bold',
  md: 'text-base px-4 py-2.5 font-semibold',
  sm: 'text-sm px-3.5 py-2 font-medium',
};

export default function TopicWallSection() {
  const [selected, setSelected] = useState<string>('撸撸射入口');
  const showToast = useToast();

  const handleClick = (label: string) => {
    setSelected(label);
    showToast(`已筛选话题：${label}`);
  };

  return (
    <section id="topics" className="scroll-mt-24 border-b border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div data-reveal className="lg:col-span-7">
            <SectionHeading
              index="03"
              eyebrow="话题墙"
              title="大家在搜什么？热门入口话题都在这"
              desc="点击任意话题即可筛选，入口相关的高频搜索词、访问疑问和线路标签都被整理成一面墙，方便你快速定位。"
            />

            <div className="mt-8 flex flex-wrap items-center gap-2.5">
              {topicTags.map((tag) => {
                const isActive = selected === tag.label;
                return (
                  <button
                    key={tag.label}
                    type="button"
                    onClick={() => handleClick(tag.label)}
                    className={`cursor-pointer whitespace-nowrap rounded-full border transition-colors ${sizeClass[tag.size]} ${
                      isActive
                        ? 'border-accent-500 bg-accent-500 text-background-50'
                        : 'border-secondary-200 bg-background-50 text-foreground-800 hover:border-primary-400 hover:text-accent-700'
                    }`}
                  >
                    #{tag.label}
                  </button>
                );
              })}
            </div>

            <div className="mt-8 flex items-center gap-4 rounded-lg border border-secondary-200 bg-background-50 p-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-price-tag-3-line text-xl" aria-hidden="true"></i>
              </span>
              <p className="text-sm text-foreground-600">
                当前话题：<span className="font-bold text-foreground-950">{selected}</span>
                ，共关联 {topicTags.length} 个入口标签，点击即为你筛选对应内容。
              </p>
            </div>
          </div>

          <div data-reveal className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-secondary-200 bg-background-50">
              <div className="relative h-[220px] w-full sm:h-[280px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20map%20like%20navigation%20artwork%2C%20warm%20sand%20and%20cream%20paper%20background%20with%20winding%20amber%20and%20vermilion%20paths%20connecting%20subtle%20nodes%2C%20editorial%20print%20texture%2C%20minimal%20geometric%20art%20direction%2C%20soft%20light%2C%20high%20detail%2C%20elegant%20and%20modern%20composition&width=1200&height=900&seq=lulu-topic-banner-01&orientation=landscape"
                  alt="撸撸射入口话题导航图"
                  title="撸撸射导航 · 话题墙与热门入口标签"
                  className="h-full w-full object-top object-cover"
                />
              </div>
              <div className="p-5 md:p-6">
                <p className="text-xs font-semibold tracking-[0.2em] text-accent-700">EDITOR'S PICK</p>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950">
                  「撸撸射入口」是本周搜索量最高的话题
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">
                  多数用户通过入口与最新地址关键词找到本站。收藏本页后，无论官网地址如何调整，都能快速回到这里重新定位可用入口。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}